import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Logo } from "./Decor";
import { COMPANY } from "../lib/data";

const LINKS = [
  { to: "/about", label: "About" },
  { to: "/services", label: "Services" },
  { to: "/industries", label: "Industries" },
  { to: "/case-studies", label: "Case Studies" },
  { to: "/process", label: "Process" },
  { to: "/contact", label: "Contact" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const [progress, setProgress] = useState(0);
  const location = useLocation();

  useEffect(() => setOpen(false), [location.pathname]);

  useEffect(() => {
    const onScroll = () => {
      const y = window.scrollY;
      setScrolled(y > 30);
      const h = document.documentElement.scrollHeight - window.innerHeight;
      setProgress(h > 0 ? (y / h) * 100 : 0);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <>
      <div id="scroll-progress" style={{ width: `${progress}%` }}></div>
      <nav className={`mv-nav ${scrolled ? "scrolled" : ""}`} data-testid="navbar">
        <div className="nav-inner">
          <Link to="/" className="nav-logo" data-testid="nav-logo-link">
            <div className="logo-box">
              <Logo size={38} />
              <div className="nav-logo-wordmark">
                <span className="nav-logo-name">{COMPANY.name}</span>
                <span className="nav-logo-tagline">Supply Chain Solutions</span>
              </div>
            </div>
          </Link>

          <ul className={`nav-links ${open ? "open" : ""}`} data-testid="nav-links">
            {LINKS.map((l) => (
              <li key={l.to}>
                <NavLink to={l.to} className={({ isActive }) => (isActive ? "active" : "")} data-testid={`nav-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}>
                  {l.label}
                </NavLink>
              </li>
            ))}
          </ul>

          <div className="nav-actions">
            <Link to="/contact" className="btn-nav" data-testid="nav-schedule-btn">Schedule a Call</Link>
            <button
              className={`hamburger ${open ? "open" : ""}`}
              aria-label="Toggle menu"
              aria-expanded={open}
              onClick={() => setOpen((o) => !o)}
              data-testid="nav-hamburger"
            >
              <span></span><span></span><span></span>
            </button>
          </div>
        </div>
      </nav>
    </>
  );
}
